import { makeImmutable } from "../core";
import { OrderLine } from "./OrderLine";
export class ProductCardCreatorResult {
    constructor(orderLines) {
        this._orderLines = orderLines;
        makeImmutable(this);
    }
    get orderLines() {
        return this._orderLines.map(([productInstanceCreator, quantity]) => {
            return new OrderLine({
                productInstanceCreator,
                quantity,
            });
        });
    }
}
